import { MediaBlock, mediaFromBlock } from "./media";
/**
 * PlaygroundMedia — test-only twin of the Media block (contract:
 * contracts/src/blocks/playground-media.ts).
 *
 * Deliberately not a component of its own: it IS `MediaBlock`, with
 * `PlaygroundMedia`'s schema behind it. That is the whole mitigation for running
 * `art-direction-per-screen`'s examples on a fixture rather than on the shipped
 * block — one renderer and one schema shape, so driving the fixture drives the
 * production path. A separate renderer here would let the two drift and quietly
 * turn eight passing examples into a claim about nothing.
 *
 * The alias exists as a file so that relationship is stated where a reader
 * looking for `PlaygroundMedia` will find it, and so the registry reads the same
 * way for every block.
 */
export { MediaBlock as PlaygroundMediaBlock } from "./media";
export const playgroundMediaBlockEntry = {
    Component: MediaBlock,
    fromBlock: mediaFromBlock,
};
//# sourceMappingURL=playground-media.js.map